import {
  IconButton,
  Text,
  Input,
  Box,
  Flex,
  Button,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  getStudentExamsRequest,
  redoExamRequest,
} from "../../../modules/admin-modules/student-exams/Actions";

const StudentExamsTable = () => {
  const studentExams = useSelector((state) => state.adminStudentExams.studentExams);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.adminStudentExams.isLoading);
  const count = useSelector((state) => state.adminStudentExams.count);

  const [searchTerm, setSearchTerm] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });

  useEffect(() => {
    const timeId = setTimeout(() => {
      dispatch(getStudentExamsRequest(searchTerm || null));
    }, 500);

    return () => {
      clearTimeout(timeId);
    };
  }, [searchTerm, dispatch]);

  const viewData = (data) => {
    setSelected(data);
  };

  const handleRedoExam = (studentExamId) => {
    const action = () => {
      setSelected({ id: "" });
    };
    dispatch(redoExamRequest(studentExamId, action));
  };

  const Data = Array.isArray(studentExams?.data?.data) 
    ? studentExams.data.data.map((data, index) => {
        return {
          ...data,
          index: `#${index + 1}`,
          id: data?.id,
          student_name: data?.student?.name || "N/A",
          phone: data?.student?.phone || "N/A",
          exam_name: data?.exam?.name || "N/A",
          score: data?.score || "N/A",
          right_answers: data?.right_answers || "0",
          wrong_answers: data?.wrong_answers || "0",
          exam_date: data?.created_at ? new Date(data.created_at).toLocaleDateString('ar-EG') : "N/A",
          status: data?.state || "N/A",
          redo: (
            <Button
              size="sm"
              colorScheme="orange"
              onClick={(e) => {
                e.stopPropagation();
                setSelected({ id: data?.id });
                handleRedoExam(data?.id);
              }}
              isLoading={selected.id === data?.id ? isLoading : false}
            >
              إعادة الاختبار
            </Button>
          ),
        };
      })
    : Array.isArray(studentExams) 
    ? studentExams.map((data, index) => {
        return {
          ...data,
          index: `#${index + 1}`,
          id: data?.id,
          student_name: data?.student?.name || "N/A",
          phone: data?.student?.phone || "N/A",
          exam_name: data?.exam?.name || "N/A",
          right_answers: data?.right_answers || "0",
          wrong_answers: data?.wrong_answers || "0",
          exam_date: data?.created_at ? new Date(data.created_at).toLocaleDateString('ar-EG') : "N/A",
          redo: (
            <Button
              size="sm"
              colorScheme="orange"
              onClick={(e) => {
                e.stopPropagation();
                setSelected({ id: data?.id });
                handleRedoExam(data?.id);
              }}
              isLoading={selected.id === data?.id ? isLoading : false}
            >
              إعادة الاختبار
            </Button>
          ),
        };
      })
    : [];

  const columns = [
    {
      Header: "رقم",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "رقم الهاتف",
      accessor: "phone",
    },
    {
      Header: "اسم الاختبار",
      accessor: "exam_name",
    },
    {
      Header: "الإجابات الصحيحة",
      accessor: "right_answers",
    },
    {
      Header: "الإجابات الخاطئة",
      accessor: "wrong_answers",
    },
    {
      Header: "تاريخ الاختبار",
      accessor: "exam_date",
    },
    {
      Header: "الحالة",
      accessor: "status",
    },
    {
      Header: "إعادة الاختبار",
      accessor: "redo",
    },
  ];

  const searchBar = (
    <Box w="100%" mb={4}>
      <Flex direction="column" gap={2}>
        <Text fontSize="lg" fontWeight="bold" color="main_1">
          البحث
        </Text>
        <Input
          placeholder="ادخل نص البحث..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          bg="white"
          border="1px solid #e2e8f0"
          borderRadius="8px"
          _focus={{
            borderColor: "main_1",
            boxShadow: "0 0 0 1px main_1",
          }}
        />
      </Flex>
    </Box>
  );

  return (
    <Box w="100%">
      {searchBar}
      <CTable
        selectedData={viewData}
        Columns={columns}
        Data={Data}
        path={"openModel"}
        Title="اختبارات الطلاب"
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={10}
        totalPage={Math.ceil(count / 10)}
      />
    </Box>
  );
};

export default StudentExamsTable;

